import React, { useEffect, useState } from "react";
import "./CandidateListPage.css";
import {
    fetchCandidates,
    deactivateCandidate,
    reactivateCandidate,
    fetchCandidateById
} from "../../api/adminCandidateApi";
import CandidateFormModal from "./CandidateFormModal";
import ExtendSubscriptionModal from "./ExtendSubscriptionModal";
import ManageSubscriptionModal from "./ManageSubscriptionModal";
import { fetchSubscription } from "../../api/adminSubscriptionApi";
const CandidateListPage = () => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showCreate, setShowCreate] = useState(false);
    const [editingCandidate, setEditingCandidate] = useState(null);
    const [statusFilter, setStatusFilter] = useState("ALL"); // ALL | ACTIVE | INACTIVE
    const [manageSubCandidate, setManageSubCandidate] = useState(null);
    const [extendSubCandidate, setExtendSubCandidate] = useState(null);

    const loadCandidates = async () => {
        try {
            const res = await fetchCandidates();
            setCandidates(res.data);
        } catch (err) {
            console.error("Failed to fetch candidates", err);
            alert("Failed to load candidates");
        } finally {
            setLoading(false);
        }
    };

    const filteredCandidates = candidates.filter(c => {
        if (statusFilter === "ALL") return true;
        return c.status === statusFilter;
    });


    useEffect(() => {
        loadCandidates();
    }, []);

    const handleDeactivate = async (id) => {
        if (!window.confirm("Deactivate this candidate?")) return;
        await deactivateCandidate(id);
        loadCandidates();
    };

    const handleReactivate = async (id) => {
        const confirmed = window.confirm(
            "Reactivate this candidate?"
        );
        if (!confirmed) return;

        await reactivateCandidate(id);
        loadCandidates();
    };

    const handleEdit = async (candidate) => {
        try {
            const res = await fetchCandidateById(candidate.id);
            setEditingCandidate(res.data); // ✅ full data
        } catch (e) {
            alert("Failed to load candidate details");
        }
    };

    const handleExtendClick = async (candidate) => {
        const res = await fetchSubscription(candidate.id);
        setExtendSubCandidate(res.data);
    };

    const handleManageClick = async (candidate) => {
        try {
            const res = await fetchSubscription(candidate.id);
            setManageSubCandidate({
                mode: "EDIT",
                data: res.data
            });
        } catch (err) {
            if (err.response?.status === 404) {
                // 👉 No subscription exists → create new
                setManageSubCandidate({
                    mode: "CREATE",
                    data: {
                        candidateId: candidate.id,
                        role: "",
                        applicationsPerDay: ""
                    }
                });
            } else {
                alert("Failed to load subscription");
            }
        }
    };


    if (loading) {
        return <p>Loading candidates...</p>;
    }

    return (
        <div className="candidates-page">
            {/* Header */}
            <div className="candidates-header">
                <div>
                    <h1>Candidates</h1>
                    <p className="subtitle">Manage all candidates</p>
                </div>
                <button
                    className="create-btn"
                    onClick={() => setShowCreate(true)}
                >
                    + Create Candidate
                </button>
            </div>

            <div className="candidates-status-filters">
                <button
                    className={`filter-btn ${statusFilter === "ALL" ? "active" : ""}`}
                    onClick={() => setStatusFilter("ALL")}
                >
                    All
                </button>

                <button
                    className={`filter-btn ${statusFilter === "ACTIVE" ? "active" : ""}`}
                    onClick={() => setStatusFilter("ACTIVE")}
                >
                    Active
                </button>

                <button
                    className={`filter-btn ${statusFilter === "INACTIVE" ? "active" : ""}`}
                    onClick={() => setStatusFilter("INACTIVE")}
                >
                    Inactive
                </button>
            </div>


            {/* Search */}
            <div className="candidates-filters">
                <input
                    type="text"
                    placeholder="Search by name or email"
                    className="search-input"
                />
            </div>

            {/* Table */}
            <div className="table-container">
                <table className="candidates-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Subscription</th>
                            <th>Assigned To</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {candidates.length === 0 && (
                            <tr>
                                <td colSpan="6">No candidates found</td>
                            </tr>
                        )}

                        {filteredCandidates.map((c) => {
                            const isActive = c.status === "ACTIVE";
                            const sub = c.subscription;

                            let subscriptionLabel = "No Subscription";
                            let subscriptionClass = "admin-badge admin-neutral";

                            if (sub) {
                                if (sub.expired) {
                                    subscriptionLabel = "Expired";
                                    subscriptionClass = "admin-badge admin-danger";
                                } else {
                                    subscriptionLabel = `Active · ${sub.daysLeft} days`;
                                    subscriptionClass = "admin-badge admin-success";
                                }
                            }

                            return (
                                <tr key={c.id}>
                                    <td>{c.name}</td>
                                    <td>{c.email}</td>

                                    <td>
                                        <span className={`admin-badge ${isActive ? "admin-active" : "admin-inactive"}`}>
                                            {c.status}
                                        </span>
                                    </td>

                                    <td>
                                        <span className={subscriptionClass}>
                                            {subscriptionLabel}
                                        </span>
                                    </td>

                                    <td>{c.assignedToName || "—"}</td>

                                    <td>
                                        <button
                                            className="link-btn"
                                            onClick={() => {
                                                handleManageClick(c);
                                            }}
                                        >
                                            Manage Sub
                                        </button>


                                        <button
                                            className="link-btn"
                                            onClick={() => {
                                                handleExtendClick(c);
                                            }}
                                        >
                                            Extend
                                        </button>


                                        <button
                                            className="link-btn"
                                            onClick={() => handleEdit(c)}
                                        >
                                            Edit
                                        </button>

                                        {isActive ? (
                                            <button
                                                className="link-btn"
                                                onClick={() => handleDeactivate(c.id)}
                                            >
                                                Deactivate
                                            </button>
                                        ) : (
                                            <button
                                                className="link-btn"
                                                onClick={() => handleReactivate(c.id)}
                                            >
                                                Reactivate
                                            </button>
                                        )}
                                    </td>

                                </tr>
                            );
                        })}
                    </tbody>

                </table>
            </div>
            {(showCreate || editingCandidate) && (
                <CandidateFormModal
                    mode={editingCandidate ? "edit" : "create"}
                    candidate={editingCandidate}
                    onClose={() => {
                        setShowCreate(false);
                        setEditingCandidate(null);
                    }}
                    onSuccess={loadCandidates}
                />
            )}

            {manageSubCandidate && (
                <ManageSubscriptionModal
                    mode={manageSubCandidate.mode}
                    subscription={manageSubCandidate.data}
                    onClose={() => setManageSubCandidate(null)}
                    onSuccess={loadCandidates}
                />
            )}


            {extendSubCandidate && (
                <ExtendSubscriptionModal
                    subscription={extendSubCandidate}
                    onClose={() => setExtendSubCandidate(null)}
                    onSuccess={loadCandidates}
                />
            )}



        </div>
    );
};

export default CandidateListPage;
